import React from "react";
import { makeStyles, Typography, Box, Switch, Tabs } from "@material-ui/core";
import * as Yup from "yup";
import { Formik, ErrorMessage } from "formik";
import { TYPES } from "./webVideoForm.container";
import { ModalFooter, ContentWrapper } from "../../modal";
import Input from "components/input/inputTextField";
import { getLang } from "app/feature/constants";
import LanguageTab from "../../tab/languageTab";

const useStyle = makeStyles((theme) => ({
  editorPaper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
    borderRadius: theme.spacing(0.5),
  },
}));

export default function WebVideoFormComponent({
  type,
  initialValues,
  handleSubmit,
  handleDelete,
  lang,
  languages,
  handleClose,
  activeUrl,
  activeIndexTab,
  handleChangeActiveIndexTab,
  setActiveUrl,
  wrongFormatLang,
}) {
  const classes = useStyle();

  return (
    <Formik
      initialValues={{
        URL: activeUrl,
        enableAutoplay: initialValues.enableAutoplay ?? false,
      }}
      validationSchema={Yup.object().shape({
        URL: Yup.string()
          // .required(getLang(languages, "message.error.FORM_VALIDATE_REQUIRED"))
          // .test(
          //   "is-valid-url",
          //   getLang(languages, "message.error.FORM_VALIDATE_WEB_VIDEO_URL"),
          //   (value) => validateURL(value)
          // ),
      })}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <form onSubmit={formik.handleSubmit}>
          <ContentWrapper resetPaper={true} disablePadding={true}>
            <Box display={lang.length === 1 ? "none" : "block"}>
              <Tabs
                value={activeIndexTab}
                onChange={handleChangeActiveIndexTab}
                textColor="primary"
                indicatorColor="primary"
                variant="scrollable"
                classes={{
                  root: classes.tabsRoot,
                  indicator: classes.indicator,
                  scrollButtons: classes.scroll,
                }}
              >
                {lang.map((label, index) => (
                  <LanguageTab
                    key={index}
                    disabled={activeIndexTab === index}
                    label={label}
                    isError={wrongFormatLang.includes(label)}
                  />
                ))}
              </Tabs>
            </Box>
            <Box className={classes.editorPaper}  p={2}>
              <Typography variant="body2" gutterBottom>
                {getLang(languages, "label.INSERT_WEB_VIDEO_URL")}{" "}
                <Typography
                  style={{ color: "#DE350B", display: "inline-block" }}
                >
                  *
                </Typography>
              </Typography>
              <Box alignItems="center" mb={3}>
                <Box>
                  <Input
                    // required
                    hiddenLabel
                    variant="filled"
                    size="small"
                    margin="normal"
                    placeholder={getLang(
                      languages,
                      "placeholder.ENTER_URL_HERE"
                    )}
                    fullWidth
                    {...formik.getFieldProps("URL")}
                    value={type === TYPES[2] ? activeUrl : activeUrl}
                    error={
                      formik.touched.URL && formik.errors.URL ? true : false
                    }
                    helperText={ErrorMessage({ name: "URL" })}
                    inputProps={{ readOnly: type === TYPES[2] }}
                    onChange={(e) => {
                      formik.setFieldValue("URL", e.target.value);
                      setActiveUrl(e.target.value);
                    }}
                  />
                  <Typography variant="body2">
                    <span style={{ color: "gray" }}>
                      {getLang(languages, "label.EXAMPLE")}&nbsp;
                    </span>
                    https://www.mywebsite.com/video.mp4
                  </Typography>
                </Box>
              </Box>
              {lang[activeIndexTab] === "EN" ? (
                <Typography variant="caption" color="textSecondary">
                  <Typography style={{ color: "#DE350B", display: "inline-block" }}>
                    *
                  </Typography>{" "}
                  {getLang(languages, "label.REQUIRED_FIELD")}
                </Typography>
              ) : null}
            </Box>
          </ContentWrapper>
          <Box
            px={2}
            py={1}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Typography variant="subtitle1">
              {getLang(languages, "label.ENABLE_AUTOPLAY")}
            </Typography>
            <Switch
              color="primary"
              checked={formik.values.enableAutoplay}
              onChange={() =>
                formik.setFieldValue(
                  "enableAutoplay",
                  !formik.values.enableAutoplay
                )
              }
            />
          </Box>
          <ModalFooter
            handleDelete={handleDelete}
            showDelete={type !== TYPES[0]}
            handleClose={handleClose}
          />
        </form>
      )}
    </Formik>
  );
}
